import type { FaireProductEntity } from "../../entity_types/product";

export const p_xzxu9gvgzn: FaireProductEntity = {
  token: "p_xzxu9gvgzn",
  type: "product",
  name: "Dirty Chai Latte (8oz x 12pk)",
  brandToken: "b_8em2suwmrj",
  brandName: "Laurel's Coffee",
  imageUrl: "https://cdn.faire.com/fastly/dea3d1660c02aa10807ea38ea47df6ce6f63e19ba8e4133a36600e576fcd30ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ffff41d36a19e58517211f14287e9b02cf6143ef7b079e42c76403f6b0bcf56b.jpeg"
  ],
  priceDollars: 30,
  description: "Vanilla Extract + Organic Cane Sugar + Chai Concentrate + Ginger Extract + Gut-Friendly A2 dairy. A spiced forward favorite.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:14.129Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
